<template>
<div class="role-form">

  <h4 id="form-title" class="mb-3">{{title}}</h4>

  <form class="evollu-form mb-5">

    <div class="row">
      <va-input
        id="role-name"
        class="col"
        v-model="form.data.name"
        :placeholder="$t('roles.name')"
        @input="form.errors.clear('name')"
        :error="form.errors.has('name')"
        :error-messages="[$t(form.errors.get('name'))]"
      />
    </div>

    <div class="row">
      <va-input
        id="role-description"
        class="col"
        v-model="form.data.description"
        type="textarea"
        :placeholder="$t('roles.description')"
        :min-rows="1"
        @input="form.errors.clear('description')"
        :error="form.errors.has('description')"
        :error-messages="[$t(form.errors.get('description'))]"
      />
    </div>

    <div class="row">
      <div class="col">
        <multiselect
          id="role-subroles"
          v-model="form.data.subRoles"
          :options="roles"
          track-by="id"
          label="name"
          :placeholder="$t('roles.subroles')"
          :allow-empty="true"
          :multiple="true"
          :close-on-select="false"
          >
          <template slot="clear">
            <span class="multiselect__clear" v-if="form.data.subRoles.length > 0" @mousedown.prevent.stop="form.data.subRoles = []"></span>
          </template>
        </multiselect>
      </div>
    </div>

    <div class="info-types">

      <table class="table table-responsive-sm">
        <thead>
          <tr>
            <th scope="col" width="25%">{{$t('roles.service')}}</th>
            <th scope="col" width="25%">Info Type</th>
            <th scope="col" width="40%">Access Type</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(infoType, index) in form.data.roleInfoTypes" :key="index">
            <td>
              {{infoType.service.name}}
            </td>
            <td>
              {{`${infoType.name} (${infoType.type})`}}
            </td>
            <td>
              <multiselect
                v-model="form.data.roleInfoTypes[index].accessType"
                :options="getAccessTypesByService(infoType.service)"
                track-by="id"
                label="name"
                placeholder="---"
                :allow-empty="true"
                :multiple="false"
                >
              <template slot="clear">
                <span class="multiselect__clear" v-if="form.data.roleInfoTypes[index].accessType !== null" @mousedown.prevent.stop="form.data.roleInfoTypes[index].accessType = null"></span>
              </template>
              </multiselect>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>

  <div class="form-actions d-flex justify-content-between">
    <va-button
      class="btn-cancel"
      @click="$emit('cancel')"
      >
      {{$t('roles.cancel')}}
    </va-button>

    <va-button
      id="btn-save"
      @click="onClickSave()"
      :disabled="form.data.name === null && form.data.name === ''">
      {{$t('roles.save')}}
    </va-button>
  </div>
</div>

</template>

<script>
import Multiselect from 'vue-multiselect'
import Errors from '@/utils/CustomNodeErrors'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    role: {
      type: Object,
      required: false,
    },
    roles: {
      type: Array,
      required: true,
    },
    infoTypes: {
      type: Array,
      required: true
    }
  },
  components: {
    Multiselect
  },
  computed: {
    services: function () {
      let services = {}
      this.infoTypes.forEach(infoType => {
        if (!services.hasOwnProperty(infoType.service_id)) {
          services[infoType.service_id] = infoType.service
        }
      })
      return Object.values(services)
    }
  },
  data: function () {
    return {
      form: {
        data: {
          name: null,
          description: null,
          roleInfoTypes: [],
          subRoles: []
        },
        errors: new Errors()
      },
      accessTypes: [
        { id: 1, name: 'Read' },
        { id: 2, name: 'Write' },
        { id: 3, name: 'Admin' }
      ]
    }
  },
  created: function () {
    if (this.role !== null && this.role !== undefined) {
      this.preFillForm()
    } else {
      this.form.data.roleInfoTypes = this.getBaseInfoTypes()
    }
  },
  methods: {
    getBaseInfoTypes: function () {
      return this.infoTypes
        .sort((a, b) => a.service.id - b.service.id)
        .map(infoType => {
          return {
            ...infoType,
            accessType: null
          }
        })
    },
    preFillForm: function () {
      this.form.data.name = this.role.name
      this.form.data.description = this.role.description
      this.form.data.subRoles = this.role.subRoles
      this.form.data.roleInfoTypes = this.getBaseInfoTypes()
      this.role.roleInfoTypes.forEach(roleInfoType => {
        let index = this.form.data.roleInfoTypes.findIndex(rit => rit.id === roleInfoType.info_type_id)
        if (index !== -1) {
          this.form.data.roleInfoTypes[index].accessType = this.accessTypes.find(a => a.id === roleInfoType.access_type) || null
        }
      })
    },
    onClickSave: function () {
      this.$emit('save')
    },
    getAccessTypesByService: function (service) {
      //console.log(service)
      if (service.id !== 2 && service.id !== 15) {
        return this.accessTypes.slice(0, 2)
      } else {
        return this.accessTypes
      }
    },
    getFormData: function () {
      return {
        name: this.form.data.name,
        description: this.form.data.description,
        subroles: this.form.data.subRoles.map(subRole => subRole.id),
        roleInfoTypes: this.form.data.roleInfoTypes
          .filter(infoType => infoType.accessType !== null)
          .map(infoType => {
            return {
              info_type_id: infoType.id,
              access_type: infoType.accessType.id
            }
          })
      }
    },
    setFormErrors: function (errors) {
      this.form.errors.record(errors, 'roles.errors.')
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss">

.role-form {
  .form-actions .va-button {
    min-width: 8rem;
  }
}

</style>
